import {Component, ElementRef, Input, OnInit, ViewChild} from '@angular/core';
import {ModalController} from '@ionic/angular';
import {Alumno} from '../../interfaces/interfaces';
import {SharedService} from "../../services/shared.service";

@Component({
  selector: 'app-foto-nota',
  templateUrl: './foto-nota.component.html',
  styleUrls: ['./foto-nota.component.scss'],
})
export class FotoNotaComponent implements OnInit {
  @ViewChild('camera', {read: ElementRef, static: true}) camera: ElementRef;
  @Input() verEtiquetas: boolean;
  @Input() etiquetas: number[] | string;
  @Input() foto: string;
  @Input() imgBase64: string;
  @Input() alumnos: Alumno[];

  todos: boolean;
  imageChangedEvent: any = '';

  constructor(
    public shared: SharedService,
    public modalCtrl: ModalController
  ) {}

  ngOnInit() {
    if (this.verEtiquetas) {
      if (this.etiquetas !== '') {
        this.etiquetas = JSON.parse(this.etiquetas as string) as number[];
        this.todos = false;
        for (const alumno of this.alumnos) {
          alumno.check = (this.etiquetas.indexOf(alumno.id) !== -1);
        }
        return
      }
      this.todos = true;
      for (const alumno of this.alumnos) {
        alumno.check = false
      }
    }
  }

  changeTodo = (ev: any) => {
    this.todos = ev.detail.checked;
    if (this.todos) {
      for (const alumno of this.alumnos) {
        alumno.check = false
      }
    }
  }

  change = (ev: any, alumno: Alumno) => alumno.check = ev.detail.checked;

  takeFoto = () => this.camera.nativeElement.click();

  resize = (ev: any) => this.imageChangedEvent = ev;

  image = (ev: any) => this.imgBase64 = ev.base64;

  borrarFoto = () => {
    this.imgBase64 = '';
    this.foto = '';
    this.todos = true;
    for (const alumno of this.alumnos) {
      alumno.check = false
    }
  }

  guardar = async () => {
    let etiq: string;
    if (this.foto === '' && this.imgBase64 === '') {
      etiq = '';
    } else if (this.todos) {
      etiq = '';
    } else {
      const tmp: number[] = [];
      for (const alumno of this.alumnos) {
        if (alumno.check) {
          tmp.push(alumno.id);
        }
      }
      etiq = JSON.stringify(tmp);
    }
    await this.modalCtrl.dismiss({
      etiquetas: etiq,
      foto: this.foto,
      imgBase64: this.imgBase64
    })
  }

}
